var _rect, _rect2, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBlog = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 36 36"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 35,
  height: 35,
  x: 0.5,
  y: 0.5,
  fill: "#EAF0FD",
  fillOpacity: 0.75,
  rx: 3.931
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 35,
  height: 35,
  x: 0.5,
  y: 0.5,
  stroke: "#2F64ED",
  rx: 3.931
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 17.723,
  r: 2.769,
  stroke: "#2F64ED"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 27.692,
  cy: 17.723,
  r: 2.769,
  stroke: "#2F64ED"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 8.308,
  cy: 17.723,
  r: 2.769,
  stroke: "#2F64ED",
  transform: "rotate(-180 8.308 17.723)"
})));
export { SvgBlog as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSIzNSIgaGVpZ2h0PSIzNSIgcng9IjMuOTMwNzciIGZpbGw9IiNFQUYwRkQiIGZpbGwtb3BhY2l0eT0iMC43NSIvPgo8cmVjdCB4PSIwLjUiIHk9IjAuNSIgd2lkdGg9IjM1IiBoZWlnaHQ9IjM1IiByeD0iMy45MzA3NyIgc3Ryb2tlPSIjMkY2NEVEIi8+CjxjaXJjbGUgY3g9IjE3Ljk5OTciIGN5PSIxNy43MjMxIiByPSIyLjc2OTIzIiBzdHJva2U9IiMyRjY0RUQiLz4KPGNpcmNsZSBjeD0iMjcuNjkyMSIgY3k9IjE3LjcyMzEiIHI9IjIuNzY5MjMiIHN0cm9rZT0iIzJGNjRFRCIvPgo8Y2lyY2xlIGN4PSI4LjMwNzkyIiBjeT0iMTcuNzIzIiByPSIyLjc2OTIzIiB0cmFuc2Zvcm09InJvdGF0ZSgtMTgwIDguMzA3OTIgMTcuNzIzKSIgc3Ryb2tlPSIjMkY2NEVEIi8+Cjwvc3ZnPgo=";